module.exports = __webpack_public_path__ + "assets/img/W2-3-F.8e295991.png";